import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { collection, getDocs, query, where, orderBy, Timestamp } from "firebase/firestore";
import { db } from "../firebase.js";
  
import { Toast } from '../components_root/ToastContext.jsx';
import { LuShoppingCart } from "react-icons/lu";
import './chart-show.css';
export default function Chartshow() {
  const { Toastshow } = Toast();
  const [isLoading, setIsLoading] = useState(true);
  const [islogin, setIslogin] = useState(false);
  const [priceData, setPriceData] = useState(0);
  const [notificationdata, setnotificationdata] = useState(0);
  const [guid, setguid] = useState('');
  const [sessiontoken, setsessiontoken] = useState([]);
  useEffect(() => {
    setguid(Cookies.get("guid"));
    const existingsessiontoken = Cookies.get("sessiontoken");
    if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
      setsessiontoken(existingsessiontoken);
      setIslogin(true);
    }
  }, []);
  const get_notification_system = async () => {
    try {
      const userQuery = query(
        collection(db, "notification_system"),        
         where("status", "==",false),
        where("guid", "==", Cookies.get("guid"))
      );
      const userSnapshot = await getDocs(userQuery);
      const dataList = userSnapshot.docs.map((doc) => ({
        uid: doc.id,
        ...doc.data(),
      }));
      setnotificationdata(dataList);
    } catch (error) {
      console.error("Error fetching price history:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    let intervalId;
    if (guid) {
      get_notification_system();
      intervalId = setInterval(() => {
        get_notification_system();
      }, 1000 * 120); // 1 minute
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [guid]);
  return (
    <div>
      <div className='chart-show'>
        <LuShoppingCart className='icon_img' />
        {notificationdata.length > 0 && (
          <div className="count_text">{notificationdata.length}</div>
        )}  
 
   
   </div>
       
       
    </div>
  );
}